import { Component, OnInit, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { ListPageColumnComponent } from 'design-system';
import { AddToCartDialog, AddToCartDialogResult } from '../add-to-cart-dialog/add-to-cart-dialog';
import { CartService } from '../../../services/cart.service';

@Component({
  selector: 'prd-add-to-cart-button',
  imports: [MatButtonModule],
  templateUrl: './add-to-cart-button.html',
  styleUrl: './add-to-cart-button.scss',
})
export class AddToCartButton extends ListPageColumnComponent implements OnInit {
  private dialog = inject(MatDialog);
  private cartService = inject(CartService);

  productId: string = '';

  ngOnInit() {
    if (this.itemData && this.infoColumn) {
      this.productId = this.itemData[this.infoColumn.columnNameDef];
    }
  }

  addToCart(event: MouseEvent) {
    event.stopPropagation();

    this.dialog.open(AddToCartDialog, {
      width: '500px',
      minHeight: '300px',
      data: {
        idProdotto: this.productId,
        nomeProdotto: this.itemData['nomeProdotto'],
        sku: this.itemData['sku'],
        nomeImballo: this.itemData['nomeImballo'],
        unitaFatturabile: this.itemData['unitaFatturabile'],
        prezzo: this.itemData['prezzo'],
        unitaMisura: this.itemData['unitaMisura'],
        prezzoMinimo: this.cartService.minimumPrice(this.productId, this.itemData['prezzoMinimoRuolo']),
      },
    }).afterClosed().subscribe((result?: AddToCartDialogResult) => {
      if (result) {
        this.cartService.updateProduct(this.productId, result.quantity, result.price)
          .subscribe({
            error: error => {
              console.error('Errore durante l\'aggiunta al carrello', error);
            },
          });
      }
    });
  }
}
